import classNames from 'classnames';

export interface ProductSelectedBoxProps {
	ppsrEnabled: boolean,
	approveEnabled: boolean,
	intelEnabled: boolean,
	isReferrer?: boolean,
	greyOutOnDisable?: boolean,
	hideNoneSelected?: boolean,
}

const ProductSelectedBox = (props: ProductSelectedBoxProps) => {
	const {
		ppsrEnabled, approveEnabled, intelEnabled, greyOutOnDisable, hideNoneSelected, isReferrer,
	} = props;

	const products = [
		{ enabled: intelEnabled, label: 'Monitor', className: 'intel' },
		{ enabled: approveEnabled, label: 'Approve', className: 'approve' },
		{ enabled: ppsrEnabled, label: 'PPSR', className: 'ppsr' },
	];

	const anyProductSelected = intelEnabled || approveEnabled || ppsrEnabled || isReferrer;

	return (
		<div className="product-selected-boxes">
			{products.map(
				({ enabled, label, className }) => {
					const clzNames = classNames('product-selected-box', className, {
						disabled: !enabled,
					});
					return (enabled || greyOutOnDisable) && <span key={className} className={clzNames}>{label}</span>
				}
			)}

			{isReferrer && <span className="product-selected-box rp">RP</span>}

			{!anyProductSelected && !hideNoneSelected && <span>None Selected</span>}
		</div>
	);
};
export default ProductSelectedBox;
